// extracted by mini-css-extract-plugin
module.exports = {"title":"edit-view-column_title__1-oMi","content":"edit-view-column_content__2ZE6y","submit":"edit-view-column_submit__2jB3h","item":"edit-view-column_item__1-qiW"};